var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.level)?_c('span',[(_vm.icon)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi",class:_vm.icon})]):_vm._e(),_c('span',{directives:[{name:"t",rawName:"v-t",value:(`staff_levels.${_vm.level}`),expression:"`staff_levels.${level}`"}]})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }